import { X, Check, UserStar } from "lucide-react";
import ProfessionalInfoForm from "../../ProfessionalInfoCollection/ProfessionalInfoForm";
import { useState } from "react";

export default function SAPCongratulations({ onClose }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[1200] bg-black/50">
      <div className="bg-white mt-20 rounded-2xl shadow-lg max-w-xl w-full p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-[#572575] transition-colors"
        >
          <X size={22} />
        </button>

        <div className="flex justify-center mb-4">
          <div className="p-1 rounded-full">
            <img
              className="h-20 w-20"
              src="/PremiumAccess/congratulations.gif"
              alt="square"
            />
          </div>
        </div>

        <h2 className="font-siromi text-[#8A40B5] text-[22px] font-normal text-center leading-[14px]">
          Congratulations!
        </h2>
        <p className="font-altis mt-4 text-[#444444] text-[16px] font-normal leading-[16px] text-center mb-6">
          You <span className=" text-bold">qualify</span> to move forward with
          your application
        </p>

        {open && <ProfessionalInfoForm onClose={() => setOpen(false)} />}

        <div className="flex justify-center">
          <button
            onClick={(prev) => prev + setOpen(true)}
            className="px-4 py-2 bg-[#572575] text-white rounded-lg font-altis font-bold text-[14px] leading-[14px] flex items-center gap-2 hover:bg-[#572575] transition"
          >
            <UserStar />
            Start Profile Completion
          </button>
        </div>
      </div>
    </div>
  );
}
